import {initializeApp}  from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyBxn581ibVJDRh_BgD1SNfFGphNogQPUO0",
    authDomain: "aciqui-c3d17.firebaseapp.com",
    databaseURL: "https://aciqui-c3d17-default-rtdb.firebaseio.com",
    projectId: "aciqui-c3d17",
    storageBucket: "aciqui-c3d17.firebasestorage.app",
    messagingSenderId: "343512633003",
    appId: "1:343512633003:web:aba0b9e855d663c304b1ee",
    measurementId: "G-J0RGZM5E2D"
};

// Inicializa Firebase
const firebase = initializeApp(firebaseConfig);

export default getMessaging(firebase)
